var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMennekesSocket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 64,
    viewBox: "0 0 75 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_17726)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M59.9123 2.00609C58.2405 1.006 56.3078 0.455655 54.3218 0.408313L47.7946 0.248535H21.8342C17.3168 0.248535 13.0069 2.01793 9.93597 5.12473C3.5096 11.6342 -0.331994 20.4516 0.023709 30.1862C0.622476 46.5842 15.9592 62.0235 33.3887 63.787C55.2348 66.0002 74.1404 50.4484 74.9704 30.2513C75.4268 19.197 69.5815 7.79361 59.9123 2.00018V2.00609ZM69.7889 30.0679C69.0716 47.4659 52.7863 60.8636 33.9696 58.964C17.8681 57.3426 5.40075 44.4893 5.18733 29.34C5.08655 21.9843 7.77211 15.2795 12.2836 10.0246C14.987 6.87637 19.0894 5.07147 23.3993 5.07147H51.737C55.8987 5.07147 59.8767 6.76985 62.5148 9.78196C67.3287 15.2854 70.1031 22.3985 69.783 30.0679H69.7889Z",
    fill: "#172228"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.2186 1.89957C57.6476 0.958657 55.8276 0.443817 53.9602 0.396475L47.8184 0.242615H23.3875C19.1368 0.242615 15.0818 1.91141 12.1947 4.83476C6.1418 10.9655 2.52549 19.2621 2.86341 28.4227C3.4266 43.8561 17.8563 58.3782 34.2601 60.041C54.8138 62.1241 72.6049 47.4896 73.3875 28.4878C73.8143 18.0845 68.3187 7.3557 59.2186 1.90549V1.89957ZM68.5084 28.3044C67.8326 44.6728 52.5136 57.2775 34.8055 55.4962C19.6585 53.9695 7.92032 41.8796 7.72468 27.6179C7.62983 20.6942 10.1553 14.3859 14.4 9.44465C16.9433 6.4858 20.8027 4.78741 24.8636 4.78741H51.5295C55.4423 4.78741 59.189 6.38519 61.6671 9.21978C66.1963 14.4037 68.8048 21.0907 68.5084 28.3103V28.3044Z",
    fill: "#3E5D68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5902 2.74582C57.0666 1.83449 55.3 1.33148 53.4859 1.28414L47.5279 1.1362H23.8203C19.6941 1.1362 15.7577 2.75173 12.9595 5.59223C7.09036 11.5395 3.58075 19.5876 3.90681 28.476C4.45815 43.4478 18.4551 57.5438 34.3728 59.1534C54.3159 61.1713 71.5793 46.9748 72.3382 28.5352C72.7532 18.4396 67.4176 8.03033 58.5902 2.7399V2.74582ZM67.6073 28.3695C66.9552 44.2526 52.0868 56.4845 34.9063 54.7506C20.2099 53.2712 8.82144 41.5364 8.62581 27.7008C8.53095 20.9842 10.9853 14.8594 15.1055 10.066C17.5717 7.19593 21.3185 5.54489 25.2549 5.54489H51.1323C54.9324 5.54489 58.5665 7.09533 60.9675 9.84706C65.3664 14.8771 67.8919 21.3629 67.6073 28.3695Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.959 26.7894C68.959 42.0571 55.7327 54.437 39.4119 54.437C23.0911 54.437 9.86483 42.0571 9.86483 26.7894C9.86483 17.9543 12.8942 11.1194 19.5992 7.57465C24.4842 4.99453 31.8651 4.5152 38.742 4.5152C45.6189 4.5152 52.6322 4.76966 57.7543 7.27877C64.9573 10.8116 68.953 17.8715 68.953 26.7954L68.959 26.7894Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3804 54.3837C22.6168 54.3837 9.79962 42.3057 9.79962 27.4523C9.79962 20.0847 12.8942 13.2083 18.5203 8.08952C21.3778 5.49164 31.0055 4.56848 38.3863 4.56848C45.7671 4.56848 55.3948 5.49164 58.2523 8.09543C63.8724 13.2143 66.973 20.0906 66.973 27.4582C66.973 42.3057 54.1499 54.3897 38.3922 54.3897L38.3804 54.3837ZM38.3804 4.71642C28.6993 4.71642 20.9391 6.08341 18.6151 8.20195C13.0247 13.2912 9.94783 20.132 9.94783 27.4582C9.94783 42.2228 22.7057 54.2417 38.3804 54.2417C54.055 54.2417 66.8129 42.2288 66.8129 27.4582C66.8129 20.132 63.7361 13.2971 58.1456 8.20195C55.8217 6.08341 48.0673 4.71642 38.3804 4.71642Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0377 49.8863C29.0372 53.786 36.6137 55.5377 44.3384 54.2239C55.632 52.3007 64.1392 44.3473 66.8188 34.5239C65.5324 32.0917 63.2203 30.0738 60.5881 28.8488C56.6516 27.0143 52.1224 26.677 47.7235 26.7244C42.8741 26.7776 37.9654 27.2747 33.4657 28.9612C28.9661 30.6478 24.8874 33.6303 22.7472 37.7017C20.7434 41.5068 20.6782 46.3001 23.0377 49.8922V49.8863Z",
    fill: "#31404C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.6516 5.39696C55.2881 4.58624 53.7171 4.14241 52.0986 4.10098L46.7809 3.97079H25.6284C21.9469 3.97079 18.4373 5.4088 15.9355 7.92382C10.6948 13.2024 7.56462 20.351 7.86104 28.2393C8.35309 41.5305 20.8383 54.0464 35.0427 55.4785C52.8397 57.2716 68.2416 44.6669 68.9175 28.2985C69.291 19.3332 64.5245 10.0956 56.6516 5.39696ZM64.6965 28.1446C64.1155 42.2465 50.8478 53.1055 35.517 51.5669C22.4034 50.2532 12.2421 39.8321 12.0702 27.5529C11.9872 21.5878 14.1748 16.1554 17.8504 11.8946C20.0498 9.34407 23.3934 7.8824 26.9089 7.8824H49.9941C53.3851 7.8824 56.6279 9.26122 58.774 11.6993C62.6986 16.1613 64.9514 21.9251 64.6965 28.1446Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7721 3.84652C56.3078 2.9707 54.6123 2.49137 52.8753 2.44403L47.1544 2.302H24.4012C20.4411 2.302 16.6647 3.85244 13.9732 6.57459C8.3353 12.2852 4.96798 20.0078 5.28219 28.5411C5.80981 42.9152 19.2435 56.4431 34.5269 57.9935C53.6756 59.9286 70.2454 46.3002 70.9746 28.6062C71.3718 18.9189 66.2497 8.92392 57.778 3.84652H57.7721ZM66.4276 28.4405C65.7991 43.6845 51.5295 55.4253 35.0368 53.7683C20.9272 52.3481 9.99525 41.0807 9.81147 27.8014C9.72255 21.357 12.0761 15.4748 16.0303 10.8708C18.3958 8.11319 21.9943 6.53316 25.7766 6.53316H50.6165C54.2625 6.53316 57.7484 8.01851 60.0605 10.6637C64.2815 15.4867 66.7121 21.718 66.4335 28.4405H66.4276Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.12402 34.1097C10.0427 47.4955 23.7965 57.9995 37.8112 57.9107C51.8912 58.0291 66.0422 48.6732 70.0024 34.9382C68.2179 41.8441 63.6709 47.8565 57.8788 51.9693C49.917 57.6562 39.3823 59.8931 29.8613 57.3604C18.7752 54.2713 9.11786 45.3119 6.12402 34.1156V34.1097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2186 1.89958C57.452 0.905409 55.4363 0.43791 53.4207 0.503005C51.3991 0.485252 49.3775 0.43791 47.3559 0.431993L35.2265 0.49117L23.097 0.443828C19.1013 0.461581 15.0996 2.02386 12.1888 4.83477C13.5701 3.35534 15.2834 2.18955 17.1449 1.36699C19.0183 0.562182 21.0517 0.124272 23.097 0.0650948C27.1461 0.0118354 31.1892 0.0236708 35.2324 0L47.3678 0.0591771C49.3894 0.112436 51.4109 0.195284 53.4325 0.266297C55.46 0.28405 57.5172 0.810726 59.2246 1.9055L59.2186 1.89958Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.792 50.6733C14.8921 45.2172 7.57055 28.2216 15.3249 16.3506C17.7674 12.5337 18.5558 10.8945 23.2037 8.57477C18.7752 11.1016 18.1705 12.7586 15.8881 16.5578C8.5843 28.3281 14.9395 43.868 30.0688 49.8271L30.798 50.6792L30.792 50.6733Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.3507 26.6474C13.3507 22.7122 16.7595 19.5284 20.9628 19.5284C25.166 19.5284 28.5748 22.7181 28.5748 26.6474C28.5748 30.5768 25.166 33.7664 20.9628 33.7664C16.7595 33.7664 13.3507 30.5768 13.3507 26.6474Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0571 22.4755C30.4423 26.1267 28.9602 31.8787 24.2174 33.222C28.3732 31.0916 29.7961 26.8368 27.0571 22.4755Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7773 32.8137C13.9495 31.5355 12.9298 29.0974 13.0306 26.7303C13.1432 23.9904 14.8269 21.3215 18.1824 20.0729C12.3725 22.2328 11.7916 29.559 16.7773 32.8137Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.3265 26.6474C19.3265 25.8012 20.0557 25.1147 20.9628 25.1147C21.8698 25.1147 22.599 25.8012 22.599 26.6474C22.599 27.4937 21.8698 28.1801 20.9628 28.1801C20.0557 28.1801 19.3265 27.4937 19.3265 26.6474Z",
    fill: "url(#paint0_linear_6_17726)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6894 19.5284C32.5281 19.5284 34.8293 17.3744 34.8293 14.7173C34.8293 12.0603 32.5281 9.90625 29.6894 9.90625C26.8507 9.90625 24.5494 12.0603 24.5494 14.7173C24.5494 17.3744 26.8507 19.5284 29.6894 19.5284Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8037 11.9005C36.092 14.3623 35.0901 18.2502 31.8829 19.1556C34.687 17.7176 35.6533 14.8475 33.8037 11.9005Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8615 18.8834C24.9526 18.0194 24.2649 16.3743 24.3301 14.7765C24.4072 12.9302 25.5454 11.1253 27.8101 10.2791C23.8855 11.7407 23.4942 16.6879 26.8615 18.8834Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.5807 14.7173C28.5807 14.1492 29.0728 13.6817 29.6834 13.6817C30.2941 13.6817 30.7861 14.1433 30.7861 14.7173C30.7861 15.2913 30.2941 15.7529 29.6834 15.7529C29.0728 15.7529 28.5807 15.2913 28.5807 14.7173Z",
    fill: "url(#paint1_linear_6_17726)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6903 14.7173C42.6903 12.0603 44.9905 9.90625 47.8302 9.90625C50.6699 9.90625 52.9701 12.0603 52.9701 14.7173C52.9701 17.3744 50.6699 19.5284 47.8302 19.5284C44.9905 19.5284 42.6903 17.3744 42.6903 14.7173Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.9504 11.9005C54.2388 14.3623 53.2369 18.2502 50.0296 19.1556C52.8338 17.7176 53.8001 14.8475 51.9504 11.9005Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0024 18.8834C43.0934 18.0194 42.4057 16.3743 42.471 14.7765C42.548 12.9302 43.6863 11.1253 45.9509 10.2791C42.0263 11.7407 41.6351 16.6879 45.0024 18.8834Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.7275 14.7173C46.7275 14.1492 47.2196 13.6817 47.8302 13.6817C48.4408 13.6817 48.9329 14.1433 48.9329 14.7173C48.9329 15.2913 48.4408 15.7529 47.8302 15.7529C47.2196 15.7529 46.7275 15.2913 46.7275 14.7173Z",
    fill: "url(#paint2_linear_6_17726)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2888 40.6842C21.2888 36.749 24.6977 33.5652 28.9009 33.5652C33.1041 33.5652 36.5129 36.7549 36.5129 40.6842C36.5129 44.6136 33.1041 47.8032 28.9009 47.8032C24.6977 47.8032 21.2888 44.6136 21.2888 40.6842Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9953 36.5182C38.3804 40.1694 36.8983 45.9214 32.1556 47.2647C36.3114 45.1344 37.7342 40.8795 34.9953 36.5182Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7154 46.8564C21.8876 45.5782 20.8679 43.1401 20.9687 40.773C21.0813 38.0331 22.765 35.3642 26.1205 34.1156C20.3106 36.2756 19.7297 43.6017 24.7154 46.8564Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.2646 40.6842C27.2646 39.838 27.9938 39.1516 28.9009 39.1516C29.8079 39.1516 30.5371 39.838 30.5371 40.6842C30.5371 41.5305 29.8079 42.2169 28.9009 42.2169C27.9938 42.2169 27.2646 41.5305 27.2646 40.6842Z",
    fill: "url(#paint3_linear_6_17726)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2241 40.6842C40.2241 36.749 43.6329 33.5652 47.8361 33.5652C52.0394 33.5652 55.4482 36.7549 55.4482 40.6842C55.4482 44.6136 52.0394 47.8032 47.8361 47.8032C43.6329 47.8032 40.2241 44.6136 40.2241 40.6842Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.9246 36.5182C57.3097 40.1694 55.8276 45.9214 51.0849 47.2647C55.2407 45.1344 56.6635 40.8795 53.9246 36.5182Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6448 46.8564C40.8169 45.5782 39.7973 43.1401 39.898 40.773C40.0107 38.0331 41.6943 35.3642 45.0498 34.1156C39.24 36.2756 38.659 43.6017 43.6448 46.8564Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.194 40.6842C46.194 39.838 46.9232 39.1516 47.8302 39.1516C48.7373 39.1516 49.4664 39.838 49.4664 40.6842C49.4664 41.5305 48.7373 42.2169 47.8302 42.2169C46.9232 42.2169 46.194 41.5305 46.194 40.6842Z",
    fill: "url(#paint4_linear_6_17726)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7683 33.7664C59.9723 33.7664 63.3804 30.5792 63.3804 26.6474C63.3804 22.7157 59.9723 19.5284 55.7683 19.5284C51.5643 19.5284 48.1563 22.7157 48.1563 26.6474C48.1563 30.5792 51.5643 33.7664 55.7683 33.7664Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8627 22.4755C65.2478 26.1267 63.7657 31.8787 59.023 33.222C63.1788 31.0916 64.6016 26.8368 61.8627 22.4755Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.5829 32.8137C48.755 31.5355 47.7354 29.0974 47.8361 26.7303C47.9488 23.9904 49.6324 21.3215 52.9879 20.0729C47.1781 22.2328 46.5971 29.559 51.5829 32.8137Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.1321 26.6474C54.1321 25.8012 54.8613 25.1147 55.7683 25.1147C56.6754 25.1147 57.4046 25.8012 57.4046 26.6474C57.4046 27.4937 56.6754 28.1801 55.7683 28.1801C54.8613 28.1801 54.1321 27.4937 54.1321 26.6474Z",
    fill: "url(#paint5_linear_6_17726)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8546 33.7664C43.0587 33.7664 46.4667 30.5792 46.4667 26.6474C46.4667 22.7157 43.0587 19.5284 38.8546 19.5284C34.6506 19.5284 31.2426 22.7157 31.2426 26.6474C31.2426 30.5792 34.6506 33.7664 38.8546 33.7664Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9549 22.4755C48.3401 26.1267 46.858 31.8787 42.1152 33.222C46.271 31.0916 47.6939 26.8368 44.9549 22.4755Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6692 32.8137C31.8414 31.5355 30.8217 29.0974 30.9225 26.7303C31.0351 23.9904 32.7188 21.3215 36.0742 20.0729C30.2644 22.2328 29.6834 29.559 34.6692 32.8137Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.4833 26.6474C36.4833 25.4225 37.5445 24.4283 38.8546 24.4283C40.1648 24.4283 41.226 25.4225 41.226 26.6474C41.226 27.8724 40.1648 28.8666 38.8546 28.8666C37.5445 28.8666 36.4833 27.8724 36.4833 26.6474Z",
    fill: "url(#paint6_linear_6_17726)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_17726",
    x1: 20.9628,
    y1: 25.1147,
    x2: 20.9628,
    y2: 28.1742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_17726",
    x1: 29.6894,
    y1: 13.6817,
    x2: 29.6894,
    y2: 15.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_17726",
    x1: 47.8302,
    y1: 13.6817,
    x2: 47.8302,
    y2: 15.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_17726",
    x1: 28.9009,
    y1: 39.1575,
    x2: 28.9009,
    y2: 42.2169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6_17726",
    x1: 47.8302,
    y1: 39.1575,
    x2: 47.8302,
    y2: 42.2169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6_17726",
    x1: 55.7683,
    y1: -0.00000302267,
    x2: 55.7683,
    y2: -0.00000302267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6_17726",
    x1: 38.8546,
    y1: 24.4283,
    x2: 38.8546,
    y2: 28.8666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_17726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMennekesSocket);
export default __webpack_public_path__ + "static/media/mennekes_socket.e3a6d8967217b6e43390ebe11039289d.svg";
export { ForwardRef as ReactComponent };